import { createAction } from '@reduxjs/toolkit';

export const eventRescheduled = createAction('eventRescheduled', ({
    id,
    rescheduled_time: rescheduledTime,
}) => {

    // WebSocket sends date without timezone info ("2025-07-15 23:30:00")
    // Adding Z suffix treats it as UTC, preventing local timezone conversion
    const formattedDate = new Date(`${rescheduledTime}Z`).toISOString();

    return {
        payload : {
            eventId: id,
            rescheduledTime: formattedDate,
        },
    };
});
